import apiOwners from './apiOwners';

/**
 * Given an API URL path (e.g., "/capital_calls/123" or "/debug/actions/generate_error"),
 * return the owning team name, or undefined if no match is found.
 */
export function getApiOwner(
  url: string | undefined,
  apiOwnersMapping: typeof apiOwners | undefined = apiOwners
): string | undefined {
  if (!url) {
    return undefined;
  }
  // Extract the first path segment using URL API to properly handle query strings
  // "/funds?fields=id" -> "funds", "/capital_calls/123" -> "capital_calls"
  const { pathname } = new URL(url, 'http://localhost');
  const firstSegment = pathname.replace(/^\//, '').split('/')[0];
  if (!firstSegment) {
    return undefined;
  }

  let longestMatch: { prefix: string; team: string } | null = null;

  for (const [prefix, team] of Object.entries(apiOwnersMapping)) {
    if (firstSegment.startsWith(prefix)) {
      if (!longestMatch || prefix.length > longestMatch.prefix.length) {
        longestMatch = { prefix, team };
      }
    }
  }

  return longestMatch?.team;
}
